import { Link } from 'react-router-dom';
import { EnvelopeSimple, Phone, InstagramLogo, TiktokLogo, YoutubeLogo, ArrowUpRight } from '@phosphor-icons/react';
import homepage from '../content/homepage.json';
import { BrandLogo } from './BrandLogo';

const socialIcons = { instagram: InstagramLogo, tiktok: TiktokLogo, youtube: YoutubeLogo };

export function Footer({ home = false }: { home?: boolean }) {
  const { contact } = homepage;
  if (home) return <footer className="contact-footer">
    <div className="section-heading section-heading-contact"><span /><h2>{homepage.contactTitle}</h2><span /></div>
    <nav className="social-links" aria-label="Liên hệ và mạng xã hội">
      <a href={`mailto:${contact.email}`} aria-label="Email"><EnvelopeSimple size={21} /></a>
      <a href={`tel:${contact.phone}`} aria-label="Điện thoại"><Phone size={21} /></a>
      {contact.socials.map(item => { const Icon = socialIcons[item.type as keyof typeof socialIcons]; return <a key={item.type} href={item.url} aria-label={item.label}><Icon size={21} /></a>; })}
    </nav>
    <div className="service-strip"><p>{contact.title}</p><strong>{contact.email}</strong><small>{contact.phone}</small><span>{contact.copyright}</span></div>
  </footer>;
  return <footer className="content-footer">
    <div className="footer-inner">
      <div><Link className="wordmark footer-wordmark" to="/" aria-label="SUiiLife — Trang chủ"><BrandLogo /></Link><p>Một chút cảm hứng.<br />Một căn bếp nhiều niềm vui.</p></div>
      <nav aria-label="Khám phá SUII"><p className="footer-label">KHÁM PHÁ</p><Link to="/">Trang chủ <ArrowUpRight size={16} /></Link><Link to="/recipes/">Công thức <ArrowUpRight size={16} /></Link><Link to="/about/">Về SUII <ArrowUpRight size={16} /></Link></nav>
      <div className="footer-contact"><p className="footer-label">KẾT NỐI VỚI CHÚNG TÔI</p><a href={`mailto:${contact.email}`}><EnvelopeSimple size={18} />{contact.email}</a><a href={`tel:${contact.phone}`}><Phone size={18} />{contact.phone}</a><span>{contact.title}</span></div>
    </div>
    <div className="footer-bottom"><span>{contact.copyright}</span><span>Chăm chút từng khoảnh khắc thường ngày.</span></div>
  </footer>;
}
